import React from 'react';
import MonsterTable from './pages/MonsterTable';
import './App.css';
import monsterImages from './data/photoList';
import TeamSelection from './pages/TeamSelection';
import monsterNames from './data/names';
import breeding from './data/breeding';
import { get } from 'lodash';

function saveTeam(team) {
  localStorage.setItem('dwm2_team', JSON.stringify(team));
}
function loadTeam() {
  try {
    return JSON.parse(localStorage.getItem('dwm2_team')) || { male: [], female: [] };
  } catch (err) {
    return { male: [], female: [] };
  }
}

const noNullMonsters = monsterNames.map((item, dex) => ({ dex, item })).filter(item => item.item !== null && !!breeding[item.dex]).map(item => item.dex);

export default class App extends React.Component {
  state = { tab: 'breeding', team: loadTeam() };

  chooseTeam = (team) => {
    this.setState({ team });
    saveTeam(team);
  }

  renderActiveTab() {
    const { tab, team } = this.state;

    if (tab === 'breeding') {
      return (
        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, overflow: 'hidden' }}>
          <MonsterTable style={{ flex: 1, marginRight: 10 }} pedigrees={get(team, 'male') || []} secondaries={get(team, 'female') || []} />
          <MonsterTable style={{ flex: 1 }} pedigrees={get(team, 'female') || []} secondaries={get(team, 'male') || []} />
        </div>
      );
    } else if (tab === 'team') {
      return <TeamSelection team={team} style={{ flex: 1 }} onChooseTeam={this.chooseTeam} />
    } else if (tab === 'everything') {
      return <MonsterTable style={{ flex: 1 }} pedigrees={noNullMonsters} secondaries={noNullMonsters} />
    }
  }

  render() {
    const { style } = this.props;
    const { tab } = this.state;

    return (
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
          <div onClick={() => this.setState({ tab: 'team' })} style={{ ...(tab === 'team' ? styles.activeStyles : {}), ...styles.headerButton }}><img style={{ width: 65/2, height: 56/2 }} src={monsterImages[16]} /> My Team</div>
          <div onClick={() => this.setState({ tab: 'breeding' })} style={{ ...(tab === 'breeding' ? styles.activeStyles : {}), marginLeft: 10, ...styles.headerButton }}><img style={{ width: 65/2, height: 56/2 }} src={monsterImages[19]} /> Breeding</div>
          <div onClick={() => this.setState({ tab: 'everything' })} style={{ ...(tab === 'everything' ? styles.activeStyles : {}), marginLeft: 10, ...styles.headerButton }}><img style={{ width: 65/2, height: 56/2 }} src={monsterImages[22]} /> Everything</div>
        </div>
        {this.renderActiveTab()}
      </div>
    );
  }
}

const styles = {
  container: {
    padding: 5,
  },
  headerButton: {
     padding: 15,
     display: 'flex',
     alignItems: 'center',
     fontSize: 22,
     fontWeight: 200,
     cursor: 'pointer',
  },
  activeStyles: {
    borderBottom: '1px solid #ccc',
  }
};
